import { render, staticRenderFns } from "./registration.vue?vue&type=template&id=5b497d88&scoped=true&"
import script from "./registration.vue?vue&type=script&lang=js&"
export * from "./registration.vue?vue&type=script&lang=js&"
import style0 from "./registration.vue?vue&type=style&index=0&id=5b497d88&scoped=true&lang=scss&"
import style1 from "./registration.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b497d88",
  null
  
)

component.options.__file = "registration.vue"
export default component.exports